App.SettingsBillingPayController = Em.Controller.extend
  env: Em.inject.service('environment')
  paymentBinding: 'model'

  isSaving: false

  actions:
    closeModal: ->
      @transitionToRoute 'settings.billing'
      false

    savePayment: ->
      return unless @get('payment.sum') > 0

      @set('isSaving', true)
      @get('model').save()
      .then (payment) =>
        paymentSecureId = payment.get('secure_id')
        window.location.href = "#{@get('env.apiRoot')}/pay/#{paymentSecureId}"
        @set('isSaving', false)
